<template>
  <div
    v-if="!hideFooter"
    class="widget-footer mt-1"
  >
    <hr>
    <div class="d-flex justify-content-between align-items-center">
      <div class="text-muted small" v-html="footer"></div>
      <div>
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-sm btn-white dropdown-toggle py-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-caret-down"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-right">
            <a
              v-if="showExploreOption"
              :href="explore"
              class="dropdown-item"
            >
              Explore
            </a>
            <a
              v-if="showEditGoalOption"
              :href="editGoal"
              class="dropdown-item"
              target="_blank"
            >
              <i class="fa fa-fw fa-bullseye mr-1"></i>
              Edit Goal
            </a>
            <a
              v-if="showExportOption"
              href="#"
              class="dropdown-item"
              @click.prevent="exportWidget"
            >
              <i class="fa fa-fw fa-envelope mr-1"></i>
              Export
            </a>
            <a
              href="javascript:;"
              class="dropdown-item"
              @click="$emit('refresh')"
            >
              <i class="fa fa-fw fa-sync mr-1"></i>
              Reload Widget
            </a>
            <div class="dropdown-divider"></div>
            <span class="dropdown-item">
              <small class="text-muted">
                {{ config.widget }}
              </small>
            </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :visible="showExportModal"
      title="Export"
      hide-footer
      @hidden="showExportModal = false"
    >
      <template v-slot:default="{ hide }">
        <p
          v-if="exporting"
        >
          Exporting...
        </p>
        <p
          v-if="!exporting && exportResult.deferred"
        >
          We're building your report now. When it's ready, we'll send the report <b>{{ exportResult.title }}</b> to {{ exportResult.email }}.
          You'll then have 30 minutes to download the file before the link expires.
        </p>
        <p
          v-if="!exporting && !exportResult.deferred"
        >
          Your export of <b>{{ exportResult.export.title }}</b> is now complete. Click the download button below
          to download the report to your computer.
        </p>
        <hr>
        <button
          v-if="exporting || exportResult.deferred"
          class="btn btn-primary btn-block"
          :disabled="exporting"
          @click="hide()"
        >
          <i
            v-if="exporting"
            class="fa fa-circle-o-notch fa-spin mr-1"
          ></i>
          <span
            v-if="!exporting"
          >
            OK
          </span>
        </button>
        <a
          v-if="!exporting && !exportResult.deferred"
          class="btn btn-primary"
          :href="exportResult.export.temporaryUrl"
        >
          <i class="fa fa-fw fa-download mr-1"></i>
          Download
        </a>
      </template>
    </b-modal>
  </div>
</template>

<style scoped lang="scss">
.dropdown-toggle {
  &::after {
    display: none;
  }
}
</style>

<script>
import { get, merge } from 'lodash'
import { mapState } from 'vuex'
import { exportWidget } from '@/api'

export default {
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      exporting: false,
      showExportModal: false,
      exportResult: {
        deferred: null,
        email: null,
        title: null,
        export: {
          temporaryUrl: null,
          title: null
        }
      }
    }
  },
  computed: {
    ...mapState('dashboard', [
      'filterValues'
    ]),
    hideFooter () {
      return get(this.$parent, 'config.options.hideFooter')
    },
    footer () {
      return this.$parent.footer || get(this.$parent, 'config.footer')
    },
    type () {
      return get(this.$parent, 'config.widget')
    },
    explore () {
      return get(this.$parent, 'config.explore')
    },
    editGoal () {
      let url = null
      if (this.challenge) {
        url = this.challenge.links.edit
      }
      return url
    },
    challenge () {
      return get(this.$parent, 'config.challenge')
    },
    showEditGoalOption () {
      return !!this.challenge && !!this.editGoal
    },
    showExploreOption () {
      return !!this.explore
    },
    showExportOption () {
      return !!get(this.$parent, 'config.exportable')
    }
  },
  methods: {
    async exportWidget () {
      let filter = merge(this.filterValues, get(this.$parent, 'config.filter', {}))
      //console.log(filter)
      this.showExportModal = true
      this.exporting = true
      let response = await exportWidget(this.type, filter)
      this.exportResult = response.data
      this.exporting = false
    }
  }
}
</script>